import { RFIRequestForm } from 'interfaces/RFIRequestForm';
import { v4 as uuid } from 'uuid';

import { NEW_RFI_REQUEST_FORM } from './constants';

export function generateNewRfxId(): string {
  const id = uuid().substring(0, 8);
  return `RFXREQ-RFI-${id}`;
}

/**
 * Create a new RFI request form
 *
 * @param businessId - the first user business
 *        buyer - buyer who created this RFI
 * @returns created RFI request form
 */
export function createNewRfiRequestForm({ businessId, buyer }: { businessId: string; buyer: string }): RFIRequestForm {
  return {
    ...NEW_RFI_REQUEST_FORM,
    generalInformation: {
      ...NEW_RFI_REQUEST_FORM.generalInformation,
      fullRfxId: generateNewRfxId(),
      businessId,
      buyer,
      workflow: businessId
    }
  };
}

/**
 * Clone a new RFI request form
 *
 * @param businessId - the first user business
 *        buyer - buyer who created this RFI
 * @returns created RFI request form
 */
export function cloneRfiRequestForm({
  currentRFI,
  buyer
}: {
  currentRFI: RFIRequestForm;
  buyer: string;
}): RFIRequestForm {
  const { fullRfxId, rfxName } = currentRFI.generalInformation;
  return {
    ...NEW_RFI_REQUEST_FORM,
    generalInformation: {
      ...currentRFI.generalInformation,
      fullRfxId: generateNewRfxId(),
      parentRfxId: fullRfxId,
      rfxName: `${rfxName}_CLONE`,
      buyer,
      beginDate: new Date().toJSON().slice(0, 10),
      beginTime: '00:00',
      dueDate: '',
      dueTime: '23:59',
      approvalLink: undefined
    },
    correspondence: currentRFI.correspondence,
    suppliers: currentRFI.suppliers,
    'co-managers': currentRFI['co-managers']
  };
}
